<template>
  <el-select v-model="tempData" placeholder="请选择" @change="change" :style="`width: ${width}`" :disabled="disabled" :clearable="clearable" filterable>
    <el-option v-for="item in list" :label="item.name" :value="item.id" :key="item.id"></el-option>
  </el-select>
</template>

<script>
  export default {
    name: "CompanySelect",
    model: {
      event: 'change',
    },
    props: {
      clearable: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      width: {
        type: String,
        default: "100%",
      },
      value: [String, Number],
    },
    data() {
      return {
        tempData: this.value,
        list: []
      }
    },
    watch: {
      value(val) {
        this.tempData = val;
      }
    },
    created() {
      this.getList();
    },
    methods: {
      async getList() {
        let nv = {
          page: 1,
          limit: 1000,
        };
        let res = await this.$Http.getCompanyOption(nv);
        if (res?.data) {
          this.list = res.data || [];
        }
      },
      change(val) {
        this.$emit('change', val)
      }
    }
  }
</script>

<style scoped>

</style>
